import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetTransactionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetTransactionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getTransaction = (request: GetTransactionRequest, options?: CashRequestOptions) =>
  post<GetTransactionRequest, GetTransactionResponse>('/2.0/cash/get-transaction', request, {
    ...options,
    rejectOnError: true,
  })
